//src/app/features/conversations/Components/ConversationRecipients/index.tsx
import useMediaQueries from 'app/hooks/useMediaQueries';
import { IUser, useGetUsersQuery, UserRoleEnum } from 'app/services/user';
import { AddCircleIcon } from 'assets/icons';
import { errorToast } from 'Components/Notifications';
import OverlayWindow, { WindowSize } from 'Components/OverlayWindow';
import { useCreatePopup } from 'Components/Popups';
import Spinner from 'Components/Spinner';
import Tooltip from 'Components/Tooltips';
import UserAvatarList from 'Components/UserAvatarList';
import { uniqBy } from 'lodash';
import { useAuth } from 'utils/AuthProvider';
import UserSelector from './UserSelector';

interface ConversationRecipientsProps {
  value?: IUser[];
  locked?: IUser[];
  canDeleteLocked?: boolean;
  onConfirm?: (allUsers: IUser[], newUsers: IUser[]) => Promise<any>;
  isMember: boolean;
}

export default function ConversationRecipients({
  value: convUsers,
  onConfirm,
  isMember,
  canDeleteLocked = false,
}: ConversationRecipientsProps) {
  const { userId, isClient } = useAuth();
  const RecipientsPopup = useCreatePopup();
  const roles = isClient
    ? [UserRoleEnum.ACCOUNTANT]
    : [UserRoleEnum.ACCOUNTANT, UserRoleEnum.ADMIN, UserRoleEnum.CLIENT];
  const { data: allUsers } = useGetUsersQuery({ roles });

  const { md_down: isMobile } = useMediaQueries();

  if (!allUsers || !userId) {
    return <Spinner bounce={false} />;
  }

  const recipients = uniqBy(
    convUsers?.filter((u) => u.id !== userId),
    'id',
  );

  return (
    <>
      <div className="flex items-center ">
        <UserAvatarList users={recipients} />

        {isMember && (
          <div className="flex items-center">
            <div
              ref={RecipientsPopup.setAnchor}
              onClick={RecipientsPopup.toggle}
              className="cursor-pointer flex items-center rounded-full"
            >
              {(!recipients || recipients.length === 0) && (
                <div className="md-max:hidden text-green font-semibold mr-2">
                  Add Recipients
                </div>
              )}
              <Tooltip message={'Add recipients'}>
                <AddCircleIcon className=" w-10 h-10 md-max:w-7 md-max:h-7 text-green  rounded-full hover:shadow" />
              </Tooltip>
            </div>
          </div>
        )}
      </div>

      {isMember && (
        <RecipientsPopup.Component placement="bottom-end">
          <OverlayWindow paddingSize="p-1" size={WindowSize.sm}>
            <UserSelector
              canDeleteLocked={canDeleteLocked}
              lockedSelections={recipients}
              userSelections={allUsers.filter((u) => u.id !== userId)}
              onConfirm={async (...args) => {
                onConfirm &&
                  onConfirm(...args)
                    .catch((e) =>
                      errorToast('Could not add recipient, try again later'),
                    )
                    .finally(RecipientsPopup.close);
              }}
            />
          </OverlayWindow>
        </RecipientsPopup.Component>
      )}
    </>
  );
}
